import { isEmptyValue } from '@/utils/common'
import AQLSummary from '../AQLSummary/AQLSummary'
import GeneralInformation from '../GeneralInformation/GeneralInformation'
import InspectionSummary from '../InspectionSummary/InspectionSummary'
import QuantityBreakdown from '../QuantityBreakdown/QuantityBreakdown'
import ReportHeader from '../ReportHeader/ReportHeader'
import SectionSummary from '../SectionSummary/SectionSummary'
import './ReportSummaryPage.style.less'
import NewQuantityBreakdown from '../NewQuantityBreakdown/NewQuantityBreakdown'
import MultiPosTable from '../MultiPosTable/MultiPosTable'
import MultiVendorStyle from '../MultiVendorStyle/MultiVendorStyle'
import GeneralInformationTJXFinal from '../GeneralInformationTJXFinal/GeneralInformationTJXFinal'
import Remark from '../Remark/Remark'
import { InspectionTemplateType } from '@/constant/qsf'
import { get } from 'lodash'
import { GradingScoreSummary } from '../GradingScoreSummaryComponent'
import { ScoreSummaryTable } from '../ScoreSummaryTable'

interface Props {
  data: any
  dataSetting: any
  user: any
  editable: boolean
  inspection: any
  orderItemSetting?: any
  extraSource?: any
}
const {
  TJX_PRE_PRODUCTION_SAMPLE,
  TJX_FINAL,
  KINGTEX_CUSTOM,
  GDS_FABRIC,
  FCCA,
} = InspectionTemplateType
const excludeQtyBreakdown = [TJX_FINAL, FCCA]

function ReportSummaryPage(props: Props) {
  const { orderItemSetting = null, data, inspection, extraSource = {} } = props
  const {
    fccaRatingSetting = [],
    isFccaNonCompliantEnabled = false,
    hiddenBlockSetting,
    auditRatingTitles,
    combinedDefectsAqlSetting = [],
  } = extraSource
  const reportType = get(data, 'inspection.template.report_type', '')
  const reportTypeTemplateValue = get(
    data,
    'inspection.template.template_value.report_type',
    ''
  )

  const renderShowAQLSummary = () => {
    if (
      [GDS_FABRIC].includes(reportTypeTemplateValue) ||
      [FCCA].includes(reportType)
    ) {
      return <></>
    }

    return (
      <AQLSummary
        data={props.data}
        option={hiddenBlockSetting}
        inspectionAql={inspection?.aql_value}
        combinedDefectsAqlSetting={combinedDefectsAqlSetting}
      />
    )
  }

  return (
    <div>
      <ReportHeader data={props.data.generalInformation} />

      {[TJX_FINAL].includes(reportType) ? (
        <GeneralInformationTJXFinal
          dataSetting={props.dataSetting}
          data={props.data}
        />
      ) : (
        <GeneralInformation dataSetting={props.dataSetting} data={props.data} />
      )}
      {[FCCA].includes(reportType) && (
        <>
          <ScoreSummaryTable
            data={props.data?.inspection?.option?.fcca}
            nonCompliantEnabled={isFccaNonCompliantEnabled}
            auditRatingTitles={auditRatingTitles}
          />
          <GradingScoreSummary
            data={props.data?.inspection?.option?.fcca?.overall_score}
            nonCompliantEnabled={isFccaNonCompliantEnabled}
            fccaRatingSetting={fccaRatingSetting}
            auditRatingTitles={auditRatingTitles}
          />
        </>
      )}
      {[TJX_PRE_PRODUCTION_SAMPLE, TJX_FINAL].includes(reportType) && (
        <MultiPosTable data={props.data} />
      )}
      {[TJX_FINAL].includes(reportType) && (
        <MultiVendorStyle data={props.data} />
      )}

      {![FCCA].includes(reportType) && (
        <InspectionSummary
          editable={props.editable}
          data={props.data.inspectionSummary}
          dataInspection={props.data.inspection}
          user={props.user}
          extraSource={extraSource}
          inspection={inspection}
        />
      )}
      {[KINGTEX_CUSTOM].includes(reportType) && <Remark />}

      {!isEmptyValue(props.data?.order) &&
        !isEmptyValue(props?.data?.generalInformation?.all_sample_sizes) &&
        ![GDS_FABRIC].includes(reportTypeTemplateValue) &&
        !excludeQtyBreakdown.includes(reportType) && (
          <QuantityBreakdown
            dataSetting={props.dataSetting}
            data={props.data?.generalInformation}
            inspection={props.data?.inspection}
          />
        )}

      <SectionSummary data={props.data.sectionSummary} />

      {renderShowAQLSummary()}
      {!isEmptyValue(props.data?.orders) &&
        !isEmptyValue(props?.data.generalInformation?.all_sample_sizes) &&
        !excludeQtyBreakdown.includes(reportType) &&
        ![GDS_FABRIC].includes(reportTypeTemplateValue) && (
          <NewQuantityBreakdown
            dataSetting={props.dataSetting}
            data={props.data}
            generalInformation={props.data?.generalInformation}
            orderItemSetting={orderItemSetting}
          />
        )}
    </div>
  )
}

export default ReportSummaryPage
